import React, {useEffect, useState} from 'react';
import Spinner from 'react-spinkit';

export const Processing = ({title}) => {

  const [opacity, setOpacity] = useState('opacity-0');

  useEffect(() => {
    setOpacity('opacity-100');
  }, [])

  return (
    <div className={`processing ${opacity}`}>
      <div className='processing-inner'>
        <h1>{title}</h1>
        <div className='spinner-wrapper'>
          <Spinner name='folding-cube' color='purple' />
        </div>
      </div>
    </div>
  )
}